import { RootState } from '@store/store';



export const selectFilter = (state: RootState) => state.filter.filter;
export const selectModifiedFilter = (state: RootState) => state.filter.modifiedFilter;

export const selectModifiedFilterDateFrom = (state: RootState) => state.filter.modifiedFilter.dateFrom;
export const selectModifiedFilterDateTo = (state: RootState) => state.filter.modifiedFilter.dateTo;

export const selectModifiedFilterDistributionTypes = (state: RootState) => state.filter.modifiedFilter.distributionTypes;
export const selectModifiedFilterOrderTypes = (state: RootState) => state.filter.modifiedFilter.orderTypes;
export const selectOnOffTrade = (state: RootState) => state.filter.modifiedFilter.onOffTrade;
export const selectModifiedFilterCountries = (state: RootState) => state.filter.modifiedFilter.countries;

export const selectModifiedFilterRegions = (state: RootState) => state.filter.modifiedFilter.regions;
export const selectModifiedFilterDistributionRegions = (state: RootState) => state.filter.modifiedFilter.distributionRegions;
export const selectModifiedFilterDistricts = (state: RootState) => state.filter.modifiedFilter.districts;
export const selectModifiedFilterDistributionDistricts = (state: RootState) => state.filter.modifiedFilter.distributionDistricts;
export const selectModifiedFilterExecutionPlaces = (state: RootState) => state.filter.modifiedFilter.executionPlaces;
export const selectModifiedFilterCustomerHierarchies = (state: RootState) => state.filter.modifiedFilter.customerHierarchies;
export const selectModifiedFilterMaterialTypes = (state: RootState) => state.filter.modifiedFilter.materialTypes;